import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';


@AutoUnsubscribe()
@Component({
    selector: 'ReportToEmail',
    templateUrl: './confirm-cancel-archive.component.html',
    styleUrls: ['./confirm-cancel-archive.component.css']
})

export class ConfirmCancelArchiveReportComponent implements OnDestroy, OnInit {



    // private snapshotToDelete: AutoRunSnapshot;

    // private _reportName: string;
    // private _autoRunDate: Date;

    // get reportName(): string {
    //     return this._reportName;
    // }

    // set reportName(value: string) {
    //     this._reportName = value;
    // }

    // get autoRunDate(): Date {
    //     return this._autoRunDate;
    // }

    // set autoRunDate(value: Date) {
    //     this._autoRunDate = value;
    // }

    // isDistributebyEmail: boolean; // ONE-4387

    selectedRecipients: string;

    header = 'Cancel Report to Archive';
    messageLine1 = 'Are you sure you want to cancel this report to archive?';
    messageLine2 = 'If you continue, this archive batch will be cancelled and any associated archived reports will be removed.';
    removeArchivedFiles = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,

        private dialogRef: MatDialogRef<ConfirmCancelArchiveReportComponent>,
        private reportService: ReportingService,
    ) {
        if (data) {
            if (data.header) {
                this.header = data.header;
            }

            if (data.messageLine1) {
                this.messageLine1 = data.messageLine1;
                this.messageLine2 = data.messageLine2;
            }
        }


        // this.snapshotToDelete = reportService.autoRunSnapshot;

        // this.autoRunDate = this.snapshotToDelete.TimeStamp;
        // this.reportName = this.snapshotToDelete.ReportName;
    }

    ngOnInit() {


    }

    continueClick() {

        // const snapshotId = this.snapshotToDelete.AutoRunReportSnapshots_ID;

        // this.reportService.deleteReportSnapshot(snapshotId).subscribe(res => {

        //     // todo: check that the delete was successful
        //     this.reportService.autoRunSnapshot = null;
        //     // this.ReportToEmailEvent.emit(true);

        //     // if (this.reportService.inDebugMode) {

        //     // }
        // });

        this.reportService.removeArchivedFiles = this.removeArchivedFiles;

        this.dialogRef.close(true);
    }

    exitClick() {
        this.dialogRef.close(false);
    }

    ngOnDestroy() {
    }

}